import { render, staticRenderFns } from "./ClubsComplainees.vue?vue&type=template&id=787d2324&scoped=true&"
import script from "./ClubsComplainees.vue?vue&type=script&lang=js&"
export * from "./ClubsComplainees.vue?vue&type=script&lang=js&"
import style0 from "./ClubsComplainees.vue?vue&type=style&index=0&id=787d2324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d2324",
  null
  
)

export default component.exports